<template>
<section class="card-panel">
  <div class="header">
    <slot name="header">
      <h2>{{ header }}</h2>
      <hr/>
    </slot>
  </div>
  <BCardGroup deck>
    <BCard
      v-for="d in data"
      :key="d.uid"
      :title="d.label"
      :img-src="src(d.image)"
      img-alt="Image"
      img-top
      :lg="4"
      :md="6"
      :sm="12"
      :class="{ 'link-card': d.route }"
      @click="$router.push(`${d.route}`)">
      <BCardText>
        {{ d.description }}
      </BCardText>
      <!-- <div -->
      <!--   v-if="d.route" -->
      <!--   slot="footer"> -->
      <!--   <BLink -->
      <!--     :to="d.route"> -->
      <!--     read more -->
      <!--   </BLink> -->
      <!-- </div> -->
    </BCard>
  </BCardGroup>
</section>
</template>
<script>

import {
  BCard,
  BCardText,
  BCardGroup,
  BLink,
  BContainer,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  name: 'CardPanel',
  props: {
    header: {
      type: String,
    },
    data: {
      type: Array,
      default: ()=>([]),
    }
  },
  data() {
    return {};
  },
  components: {
    'b-link': BLink,
    'b-card': BCard,
    'b-card-group': BCardGroup,
    'b-card-text': BCardText,
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol,
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    src(img){
      try{
        return require(`@/assets/img/${img}`);
      } catch(err){
        //let i = Math.round(Math.random()*50+1)
        //return `https://picsum.photos/400/400/?image=${i}`
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.card-panel  {
  padding: 1rem;
  max-width: $max-content-width;
  margin: 0 auto;

  .link-card {
    cursor: pointer;
    &:hover {
      @include shadow;
    }
  }

  @media screen and (min-width: $break-sm) {
    .card {
      flex: 0 0 calc(50% - 30px);
      margin-bottom: 1rem;
    }
  }

  @media screen and (min-width: $break-md) {
    .card {
      flex: 0 0 calc(50% - 30px);
      margin-bottom: 1rem;
    }
  }

  @media screen and (min-width: $break-lg) {
    .card {
      flex: 0 0 calc(25% - 30px);
    }
  }

}
</style>
